import type { QueryClient } from "@tanstack/react-query";

export const therapyContextKey = ["therapies", "measurement-context"] as const;

// Therapy context contains both prescriptions and measurements. Either kind of
// mutation must invalidate it, including a measurement imported from backup.
export function invalidateMeasurements(client: QueryClient) {
  return Promise.all([
    client.invalidateQueries({ queryKey: ["dashboard"] }),
    client.invalidateQueries({ queryKey: ["records"] }),
    client.invalidateQueries({ queryKey: therapyContextKey }),
  ]);
}
